import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessageTypes } from './toast.enum';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent implements OnChanges {
  /** Message*/
  @Input() message = '';
  /** Message type input*/
  @Input() type = '';
  /** Toast duration */
  @Input() duration = 5000;
  /** Show toast message flag */
  @Input() showToast = false;
  /** Emit new show toast flag value */
  @Output() showToastChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  /** Message types */
  messageTypes = MessageTypes;
  /** Timeout reference */
  timeoutReference: any;
  /** Messages types configuration */
  messageTypesConfig: any = {
    [MessageTypes.SUCCESS]: {
      id: 'toast-success',
      mainClass: 'dark:text-green-400 text-green-800 bg-green-50',
      iconClass: 'text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200',
      buttonClass: 'bg-green-50 text-green-500 focus:ring-green-400 hover:bg-green-200 dark:text-green-400',
    },
    [MessageTypes.ERROR]: {
      id: 'toast-danger',
      mainClass: 'dark:text-red-400 text-red-800 bg-red-50',
      iconClass: 'text-red-500 bg-red-100 dark:bg-red-800 dark:text-red-200',
      buttonClass: 'bg-red-50 text-red-500 focus:ring-red-400 hover:bg-red-200 dark:text-red-400',
    },
    [MessageTypes.WARNING]: {
      id: 'toast-warning',
      mainClass: 'dark:text-yellow-400 text-yellow-800 bg-yellow-50',
      iconClass: 'text-yellow-500 bg-yellow-100 dark:bg-yellow-800 dark:text-yellow-200',
      buttonClass: 'bg-yellow-50 text-yellow-500 focus:ring-yellow-400 hover:bg-yellow-200 dark:text-yellow-400',
    },
  };

  private hideToastTimeout: any;
  private resetTypeTimeout: any;
  ngOnChanges(changes: SimpleChanges): void {
    this.message = changes.message?.currentValue ?? this.message;
    this.type = changes.type?.currentValue ?? this.type;
    this.showToast = changes.showToast?.currentValue ?? this.showToast;
    if (this.showToast) {
      clearTimeout(this.timeoutReference);
      this.timeoutReference = setTimeout(() => {
        this.closeToast();
      }, this.duration);
    }
  }

  /**
   * Close toast message
   */
  closeToast(): void {
    this.showToast = false;
    this.showToastChange.emit(this.showToast);
    clearTimeout(this.timeoutReference);
  }
}

@NgModule({
  declarations: [ToastComponent],
  exports: [ToastComponent],
  imports: [CommonModule, TranslateModule],
})
export class SystemToastModule {}
